var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImportDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5292 20.508L20.4565 20.4422L20.8822 18.5614C22.4454 11.655 28.6237 6.5 36 6.5C43.3763 6.5 49.5546 11.655 51.1178 18.5614L51.5435 20.4422L53.4708 20.508C60.7077 20.7552 66.5 26.7017 66.5 34C66.5 41.4558 60.4558 47.5 53 47.5H50V50H53C61.8366 50 69 42.8366 69 34C69 25.3496 62.1352 18.3025 53.5561 18.0095C51.7407 9.98877 44.5697 4 36 4C27.4303 4 20.2593 9.98877 18.4439 18.0095C9.86484 18.3025 3 25.3496 3 34C3 42.8366 10.1634 50 19 50H21V47.5H19C11.5442 47.5 5.5 41.4558 5.5 34C5.5 26.7017 11.2923 20.7552 18.5292 20.508Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2501 37.75V62.9288L43.9782 56.0324L45.7677 57.7782L36.0001 67.79L26.2324 57.7782L28.0219 56.0324L34.7501 62.9288V37.75H37.2501Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportDevice);
export default __webpack_public_path__ + "static/media/icon-import-device.0bd84221519f33d311dfbd294ba50a96.svg";
export { ForwardRef as ReactComponent };